import * as Yup from "yup";

export const JobPostingSchema = Yup.object({
  title: Yup.string().trim().required("The title field is required."),
  description: Yup.string()
    .trim()
    .required("The description field is required."),
  thumbnail:Yup.object().optional().nullable(),
  branch_id: Yup.number()
    .required("The branch field is required."),
  min_salary_offer: Yup.number()
    .optional().nullable(),
  max_salary_offer: Yup.number()
    .optional().nullable(),
  job_type: Yup.string()
    .trim()
    .required("The job type field is required.")
    .oneOf(
      ["Full Time", "Part Time", "Contractual", "Fixed Term"],
      "There is no available option for that"
    ),
  no_of_openings: Yup.number().min(1,"The minimum number of opening is 1").required(
    "The number of openings field is required"
  ),
  schedule: Yup.date().required("The schedule field is required"),
  qualification: Yup.string().required("The qualification field is required"),
  duties_and_responsibilties:Yup.string().required('The duties and responsibilities field is required'),
});

// PHP Regex to match a string that contains a number
// test("salary_offer", "The salary offer is incorrect format", (value) => {
//   /* ACCEPTED REGEX:
//     1.23
//     1,000.00
//     1,000.
//     999,999.00 
//     !! Will be conflict on the schema that says db.Decimal(19,2) !!
//     */
//   const regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
//   return regex.test(value);
// })

export default JobPostingSchema
